import { DeductionFetchMode } from "@/core/deduction/FetchMode";

export interface IResolveDeductionFetchModeParams {
  statusId: "all" | "incomplete" | number;
  groupByCheck: boolean;
}

/**
 * Pure policy: given the current quick-filter tab and the group-by-check
 * toggle, decide which fetch mode the page should use.
 *
 * Rule: only "all" / "incomplete" tabs respect `groupByCheck`. On any
 * stage-number tab we always flat-fetch remittance items.
 */
export class ResolveDeductionFetchModeUseCase {
  execute({ statusId, groupByCheck }: IResolveDeductionFetchModeParams): DeductionFetchMode {
    const isAllOrIncomplete = statusId === "all" || statusId === "incomplete";
    if (groupByCheck && isAllOrIncomplete) {
      return DeductionFetchMode.RemittanceGrouped;
    }
    return DeductionFetchMode.RemittanceItemFlat;
  }
}
